import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';

import { getPreLeaseDaysOnMarket, getMoveInReadyDaysOnMarket } from 'common/preLeaseHelpers';

import SrLink from 'client/components/SrLink/SrLink';
import SrCard from 'client/components/SrCard/SrCard';

import './SrDaysOnMarketComparativeMarketAnalysisCard.less';

const SrDaysOnMarketComparativeMarketAnalysisCard = ({ listing }) => {
  const preLeaseDaysOnMarket = listing.preLease
    ? getPreLeaseDaysOnMarket({
        listing: listing,
        preLease: listing.preLease,
      })
    : null;

  const moveInReadyDaysOnMarket = listing.preLease
    ? getMoveInReadyDaysOnMarket({
        listing: listing,
        preLease: listing.preLease,
      })
    : listing.daysOnMarket;

  const comparativeMarketAnalysisPdfUrl = `/pdf-viewer?pdfUrl=${encodeURIComponent(
    listing.comparativeMarketAnalysisPdfUrl,
  )}`;

  const isOverMedianDOM =
    listing.daysOnMarket > listing.comparativeMarketAnalysisMedianDaysOnMarket * 1.1;

  return (
    <SrCard padding="18px 12px 12px" maxWidth="100%" styleName="srCard">
      <span styleName="cardTitle">Days on Market compared to similar listings</span>

      <div styleName="cards">
        <div styleName="card yellow">
          <span styleName="title">Median DOM</span>
          <span styleName="number">{listing.comparativeMarketAnalysisMedianDaysOnMarket}</span>
          <span styleName="text">From CMA</span>
          <SrLink styleName="text link" target="_blank" to={comparativeMarketAnalysisPdfUrl}>
            View Report (created{' '}
            {moment(listing.comparativeMarketAnalysisUpdated).format('MMM DD, YYYY')})
          </SrLink>
        </div>
        <div
          styleName={classnames('card', {
            green: !isOverMedianDOM,
            orange: isOverMedianDOM,
          })}
        >
          <span styleName="title">Listing DOM</span>
          <span styleName="number green">{moveInReadyDaysOnMarket}</span>
          <span styleName="text">Move-In Ready DOM</span>
          {preLeaseDaysOnMarket && (
            <span styleName="text">(+{preLeaseDaysOnMarket} days in Pre-Lease)</span>
          )}
        </div>
      </div>
    </SrCard>
  );
};

SrDaysOnMarketComparativeMarketAnalysisCard.propTypes = {
  listing: PropTypes.object.isRequired,
};

SrDaysOnMarketComparativeMarketAnalysisCard.displayName =
  'SrDaysOnMarketComparativeMarketAnalysisCard';

export default SrDaysOnMarketComparativeMarketAnalysisCard;
